import type {z} from "zod";

import {AddServiceDescriptionBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {serviceDescriptionFieldLabelIds} from "../../../../../messages/service-description.messages";

export const addServiceDescriptionFormSchema = zod.object({
  language: AddServiceDescriptionBody.shape.language,
  text: requiredStringSchema(
    AddServiceDescriptionBody.shape.text,
    serviceDescriptionFieldLabelIds.text,
  ),
});
export type AddServiceDescriptionFormPayload = z.output<typeof addServiceDescriptionFormSchema>;

export const draftAddServiceDescriptionFormSchema = addServiceDescriptionFormSchema.partial();
export type DraftAddServiceDescriptionFormPayload = z.output<
  typeof draftAddServiceDescriptionFormSchema
>;
